var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9375 8.6875H12.0625C10.1985 8.6875 8.6875 10.1985 8.6875 12.0625V19.9375C8.6875 21.8015 10.1985 23.3125 12.0625 23.3125H19.9375C21.8015 23.3125 23.3125 21.8015 23.3125 19.9375V12.0625C23.3125 10.1985 21.8015 8.6875 19.9375 8.6875ZM12.0625 7C9.26656 7 7 9.26656 7 12.0625V19.9375C7 22.7334 9.26656 25 12.0625 25H19.9375C22.7334 25 25 22.7334 25 19.9375V12.0625C25 9.26656 22.7334 7 19.9375 7H12.0625ZM16 19.375C17.864 19.375 19.375 17.864 19.375 16C19.375 14.136 17.864 12.625 16 12.625C14.136 12.625 12.625 14.136 12.625 16C12.625 17.864 14.136 19.375 16 19.375ZM16 21.0625C18.7959 21.0625 21.0625 18.7959 21.0625 16C21.0625 13.2041 18.7959 10.9375 16 10.9375C13.2041 10.9375 10.9375 13.2041 10.9375 16C10.9375 18.7959 13.2041 21.0625 16 21.0625ZM20.7921 12.3329C21.4135 12.3329 21.9171 11.8292 21.9171 11.2079C21.9171 10.5865 21.4135 10.0829 20.7921 10.0829C20.1708 10.0829 19.6671 10.5865 19.6671 11.2079C19.6671 11.8292 20.1708 12.3329 20.7921 12.3329Z",
    fill: "#252429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c1b8ed78674da24d051350021941abd0.svg";
export { ForwardRef as ReactComponent };